export function setupAnimations(gsap, ScrollTrigger) {
    gsap.defaults({
        overwrite: "auto",
        duration: 0.6,
        ease: "power3.out"
    });

    const getAnimation = (element, animation) => {
        switch (animation) {
            case '.anim__zoomIn':
                gsap.fromTo(element, { scale: 0.8, autoAlpha: 0 }, { scale: 1, autoAlpha: 1 });
                break;
            case '.anim__fadeIn':
                gsap.fromTo(element, { autoAlpha: 0 }, { autoAlpha: 1 });
                break;
            case ".anim__fadeInUp":
                gsap.fromTo(element, { y: 10, autoAlpha: 0 }, { y: 0, autoAlpha: 1 });
                break;
            case ".anim__fadeInDown":
                gsap.fromTo(element, { y: -10, autoAlpha: 0 }, { y: 0, autoAlpha: 1 });
                break;
            case ".anim__fadeInLeft":
                gsap.fromTo(element, { x: 10, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });
                break;
            case ".anim__fadeInRight":
                gsap.fromTo(element, { x: -10, autoAlpha: 0 }, { x: 0, autoAlpha: 1 });
                break;
        }
    };

    const targets = [
        ".anim__zoomIn",
        ".anim__fadeIn",
        ".anim__fadeInUp",
        ".anim__fadeInDown",
        ".anim__fadeInLeft",
        ".anim__fadeInRight",
    ];

    const initializeAnimations = (container = document) => {
        targets.forEach((target) => {
            const elements = container.querySelectorAll(target);
            elements.forEach((element) => {
                // Check if this element already has an animation
                if (!element.hasAttribute('data-animated')) {
                    ScrollTrigger.create({
                        trigger: element,
                        start: "top 80%",
                        once: true,
                        onEnter: () => {
                            getAnimation(element, target);
                            element.setAttribute('data-animated', 'true');
                        }
                    });
                }
            });
        });
    };

    // Initial setup
    initializeAnimations();

    // Refresh animations after AJAX load for new content only
    const refreshAnimationsForNewContent = () => {
        // Check if any element with data-ajax-loaded="true" exists
        const newContentContainers = document.querySelectorAll('[data-ajax-loaded="true"]');
        
        if (newContentContainers.length > 0) {
            newContentContainers.forEach(container => {
                // Initialize animations only for new elements within this container
                initializeAnimations(container);
                
                // Remove the attribute after processing
                container.removeAttribute('data-ajax-loaded');
            });
            
            // Refresh ScrollTrigger to recalculate positions
            ScrollTrigger.refresh();
        }
    };

    // Use MutationObserver to detect new content
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                    // Check if the added node or its children have data-ajax-loaded attribute
                    if (node.hasAttribute && node.hasAttribute('data-ajax-loaded')) {
                        refreshAnimationsForNewContent();
                    } else if (node.querySelector) {
                        const hasNewContent = node.querySelector('[data-ajax-loaded="true"]');
                        if (hasNewContent) {
                            refreshAnimationsForNewContent();
                        }
                    }
                }
            });
        });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}